import $api from "."

export default function fetchBlogs(){
   return $api.get('post?sort=-post_date')
}